import React from "react";
import NotificationMessage from "../../../components/notification";
import SectionTitle from "../../../components/sectionTitle";
import CallToAction from "../partials/cta";
import DetailsMismatch from "./mismatch";
import ErrorMessage from "../partials/error";
import SectionForm from "./bank";
import FieldLabel from "../../../components/label";
import VerifiedIcon from "@mui/icons-material/Verified";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import { Box, Stack } from "@mui/material";
import { isBankDetailsProceedButtonDisabled } from "../../../helpers/validation";
import { BUTTON_PROCEED, BUTTON_VERIFY_AND_PROCEED } from "../../../constants";

function BankDetailsForm({
  classes: { containerButton, formGroup, main },
  banks,
  branchName,
  errorMessage,
  errors,
  form,
  handleAccordionChange,
  handleBack,
  handleChange,
  handleChangeChipSelect,
  handleClose,
  handleModalProceed,
  handleTestDetailsCheckbox,
  handleVerifyClick,
  isFormSubmitted,
  isTestDetails,
  modal,
  onSubmit,
  options,
  salesPersonList = [],
  branchNameList = [],
  section,
  selectedBankOption,
  setSelectedBankOption,
  selectedSalesPersonOption,
  setSelectedSalesPersonOption,
  selectedBranchNameOption,
  setSelectedBranchNameOption,
  validateInputLength,
}) {
  return (
    <Box className={main} p={0}>
      <Box mt={2}>
        <Box display="flex" justifyContent="center" m={2} mt={0} mb={0}>
          <SectionTitle title={"Bank Details"} onClickHandler={handleBack} />
        </Box>
        <form noValidate autoComplete="off" onSubmit={onSubmit}>
          <Box direction="column">
            <SectionForm
              banks={banks}
              branchName={branchName}
              errorMessage={errorMessage}
              form={form}
              handleAccordionChange={handleAccordionChange}
              handleChange={handleChange}
              handleChangeChipSelect={handleChangeChipSelect}
              handleTestDetailsCheckbox={handleTestDetailsCheckbox}
              handleVerifyClick={handleVerifyClick}
              isTestDetails={isTestDetails}
              options={options}
              salesPersonList={salesPersonList}
              branchNameList={branchNameList}
              section={section}
              selectedBankOption={selectedBankOption}
              setSelectedBankOption={setSelectedBankOption}
              selectedSalesPersonOption={selectedSalesPersonOption}
              setSelectedSalesPersonOption={setSelectedSalesPersonOption}
              selectedBranchNameOption={selectedBranchNameOption}
              setSelectedBranchNameOption={setSelectedBranchNameOption}
              validateInputLength={validateInputLength}
            />
          </Box>

          <ErrorMessage errors={errors} modal={modal} />

          <Box
            className={containerButton}
            justifyContent="center"
            alignContent="center"
          >
            {form?.verify_account_details && (
              <Box className={formGroup} pt={0}>
                <Stack
                  justifyContent="center"
                  alignItems="center"
                  direction="row"
                  gap={0.5}
                >
                  <VerifiedIcon sx={{ color: "green" }} />
                  <Box>
                    <FieldLabel
                      label={"The above account details are verified."}
                    />
                  </Box>
                </Stack>
              </Box>
            )}

            <CallToAction
              buttonType={"submit"}
              errorMessage={errorMessage}
              form={form}
              isDisabled={isBankDetailsProceedButtonDisabled(
                isFormSubmitted,
                form,
                errorMessage,
                selectedBankOption,
                selectedSalesPersonOption,
                selectedBranchNameOption,
                branchName,
                isTestDetails
              )}
              isFormSubmitted={isFormSubmitted}
              text={
                form?.verify_account_details
                  ? BUTTON_PROCEED
                  : BUTTON_VERIFY_AND_PROCEED
              }
              handleClick={() => {}}
            />
          </Box>

          {modal.snackbar && (
            <NotificationMessage
              open={modal.snackbar}
              message={"Appropriate message need to place here."}
              onClose={() => handleClose("snackbar", false)}
            />
          )}

          {modal.mismatch && (
            <DetailsMismatch
              form={form}
              onClickHandler={handleModalProceed}
              handleClose={handleClose}
              modal={modal}
            />
          )}
        </form>
      </Box>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(BankDetailsForm);
